<div class="breadcrumbs overlay">
    <div class="container">
        <div class="bread-inner">
            <div class="row">
                <div class="col-12">
                    <h2>MISSION</h2>
                </div>
            </div>
        </div>
    </div>
</div>
<br>

<!-- Start Mission Section -->
<section class="why-choose section">
    <div class="container">
        <div class="row d-flex align-items-start"> <br>
            <!-- Start Text Section -->
            <div class="col-md-6">
                <div class="choose-left"><br>
                    <h3>MISSION</h3>
                    <p class="mission-text">
                        La Cour des Comptes du Bénin est chargée du contrôle a posteriori de la gestion des finances publiques et des comptes des administrations publiques.
                    </p>

                    <div class="compresser">
                        <ul class="mission-list">
                            <li>Contrôler les comptes des ministères, services et organismes de l'État</li>
                            <li>Établir les comptes généraux de l'État</li>
                            <li>Contrôler la gestion financière et patrimoniale des établissements publics</li>
                            <li>Exercer un contrôle sur les collectivités territoriales</li>
                            <li>Assurer le contrôle des entreprises du portefeuille de l'État</li>
                            <li>Rédiger des rapports d'observations définitives et des rapports spéciaux</li>
                            <li>Appuyer le Parlement dans l'exercice de son contrôle des finances publiques</li>
                            <li>Contribuer à l'amélioration de la gouvernance publique</li>
                            <li>Veiller à la bonne utilisation des fonds publics</li>
                            <li>Publier un rapport annuel d'activités</li>
                        </ul>
                    </div>

                    <div class="justify-content-end mt-4">
                        <a (click)="goToMission()" href="javascript: void(0);" class="btn btn-primary"
                            rel="noopener">Métiers</a>
                    </div><br>
                </div>
            </div>
            <!-- End Text Section -->

            <!-- Start Image Section -->
            <div class="col-md-6 d-flex justify-content-center align-items-center mt-4 mr-4"><br>
                <img src="../../../assets/img/ccb-batiment.jpg" class="img-fluid rounded" alt="Cour des Comptes du Bénin" style="max-height: 350px;">
            </div>
            <!-- End Image Section -->


        </div>
    </div>
</section>
<br><br>
<!--/ End Mission Section -->
